import React from "react";
import ReactDOM from "react-dom/client";
import { ProductCard } from "@app/components/ProductCard";

const product = {
  id: "gid://shopify/Product/9394363662632",
  handle: "a-really-really-long-product-name-copy",
  title: "A Really Really Long Product Name (Copy)",
  availableForSale: true,
  tags: ["essential", "pre-order"],
  isGiftCard: false,
  priceRange: {
    maxVariantPrice: {
      currencyCode: "AUD",
      amount: "29.99",
    },
    minVariantPrice: {
      currencyCode: "AUD",
      amount: "29.99",
    },
  },
  compareAtPriceRange: {
    maxVariantPrice: {
      currencyCode: "AUD",
      amount: "29.99",
    },
    minVariantPrice: {
      currencyCode: "AUD",
      amount: "29.99",
    },
  },
};

/**
 * Mount product cards for testing purposes.
 */

const test1 = document.querySelector(".product-card-test-1");
if (test1) {
  const root = ReactDOM.createRoot(test1);

  root.render(<ProductCard product={product} />);
}

const test2 = document.querySelector(".product-card-test-2");
if (test2) {
  const root = ReactDOM.createRoot(test2);
  const product2 = {
    ...product,
    compareAtPriceRange: {
      ...product.compareAtPriceRange,
      maxVariantPrice: { ...product.compareAtPriceRange.maxVariantPrice, amount: "49.99" },
    },
  };
  root.render(<ProductCard product={product2} />);
}
